(() => {
  const storageKey = 'agriva-price-display';
  const root = document.documentElement;

  if (root.dataset.priceDisplayMarket !== 'NO') return;

  const updatePrices = (container) => {
    if (container.matches?.('[data-vat-price]')) {
      const value =
        root.dataset.priceDisplay === 'exclusive'
          ? container.dataset.vatExclusive
          : container.dataset.vatInclusive;

      if (value !== undefined) container.textContent = value;
    }

    container.querySelectorAll?.('[data-vat-price]').forEach((price) => {
      const value =
        root.dataset.priceDisplay === 'exclusive'
          ? price.dataset.vatExclusive
          : price.dataset.vatInclusive;

      if (value !== undefined) price.textContent = value;
    });
  };

  const setPriceDisplay = (display, persist = false) => {
    if (display !== 'inclusive' && display !== 'exclusive') {
      console.error(`Unsupported AGRIVA price display mode: ${display}`);
      return;
    }

    root.dataset.priceDisplay = display;
    updatePrices(document);

    document.querySelectorAll('[data-price-display-choice]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.priceDisplayChoice === display));
    });

    if (persist) {
      try {
        localStorage.setItem(storageKey, display);
      } catch (error) {
        console.error('AGRIVA price display preference could not be saved to localStorage.', error);
      }
    }
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const button = event.target.closest('[data-price-display-choice]');
    if (button) setPriceDisplay(button.dataset.priceDisplayChoice, true);
  });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach(({ addedNodes }) => {
      addedNodes.forEach((node) => {
        if (node instanceof Element) updatePrices(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  setPriceDisplay(root.dataset.priceDisplay === 'exclusive' ? 'exclusive' : 'inclusive');
})();
